// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"CheckBox_checkbox__21F5y"};